(function (Drupal, $) {
  Drupal.behaviors.searchScrollToResults = {
    attach: function (context) {
      if (context === document) return;
      var resultsSection = context.querySelector('.search-listing-content');
      if (!resultsSection) return;
      var headerOffset = document.querySelector('header.site-header, .site-header, header');
      var offset = headerOffset ? headerOffset.offsetHeight : 0;
      var top = resultsSection.getBoundingClientRect().top + window.scrollY - offset - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  Drupal.behaviors.searchClearButton = {
    attach: function (context) {
      const queryItem = context.querySelector('.page-search-listing .form-item-query');
      if (!queryItem || queryItem.dataset.clearBtnInit) return;
      queryItem.dataset.clearBtnInit = 'true';

      const input = queryItem.querySelector('input[type="text"]');
      if (!input) return;

      const clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.className = 'search-clear-btn';
      clearBtn.setAttribute('aria-label', 'Clear search');
      clearBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>`;
      queryItem.appendChild(clearBtn);

      const update = () => queryItem.classList.toggle('has-value', input.value.length > 0);
      input.addEventListener('input', update);
      update();

      clearBtn.addEventListener('click', () => {
        input.value = '';
        input.focus();
        update();
      });
    }
  };
})(Drupal, jQuery);
